export default {
  background_image: 'Taustakuva',
  file_too_large: 'Tiedosto on liian suuri. Enimmäiskoko on {{max}} Mt.',
  upload_failed: 'Lataus epäonnistui. Yritä uudelleen.',
};
